import store from '../../../../state';
import { ForecastWidgetConfig, WidgetRenderContext, WidgetRenderer } from '../types';

export class StatGridWidget implements WidgetRenderer {
  private formatValue(key: string, ctx: WidgetRenderContext): string {
    const data = ctx.data;
    const isImperial = store.getState().units === 'imperial';

    switch (key) {
      case 'temps_forecast':
      case 'temps_f':
        return data.tempsForecast?.[0] !== undefined ? `${Math.round(data.tempsForecast[0])}°` : '--';
      case 'darkskies_score':
        return data.darkskiesScore !== undefined ? `${data.darkskiesScore.toFixed(1)}/10` : '--';
      case 'moon_phase':
        return data.moonName ? `${data.moonIcon} ${data.moonName}` : '--';
      case 'moon_illumination':
        return data.moonIllumination || '--';
      case 'cloud_cover':
      case 'cloud_cover_total':
        return data.cloudCover?.[0] !== undefined ? `${Math.round(data.cloudCover[0])}%` : '--';
      case 'wind_speed':
        return data.windSpeed?.[0] !== undefined ? `${Math.round(data.windSpeed[0])} ${isImperial ? 'mph' : 'km/h'}` : '--';
      case 'max_sun_intensity':
        return data.maxSunIntensity !== undefined ? `${data.maxSunIntensity} W/m²` : '--';
      case 'freezing_level':
        return data.avgFreezingElev !== undefined ? `${Math.round(isImperial ? data.avgFreezingElev : data.avgFreezingElev / 3.28084)} ${isImperial ? 'ft' : 'm'}` : '--';
      default:
        return '--';
    }
  }

  public renderHtml(widget: ForecastWidgetConfig, ctx: WidgetRenderContext): string {
    const title = widget.title || 'Quick Glance Metrics';
    const columns = widget.options?.columns || 2;
    const tiles: any[] = widget.options?.tiles || [
      { key: 'temps_forecast', icon: '🌡️', label: 'Temperature', subtext: 'Surface' },
      { key: 'cloud_cover', icon: '☁️', label: 'Cloud Cover', subtext: 'Total deck' }
    ];

    const tilesHtml = tiles.map(t => {
      const val = this.formatValue(t.key, ctx);
      const icon = t.icon || '📊';
      const label = t.label || t.key;
      const subtext = t.subtext || '';
      const color = t.color || '#38bdf8';

      return `
        <div style="background: rgba(0, 0, 0, 0.25); border: 1px solid rgba(255,255,255,0.04); border-radius: 6px; padding: 10px; display: flex; flex-direction: column; gap: 4px;">
          <div style="display: flex; justify-content: space-between; align-items: center;">
            <span style="font-size: 0.72rem; color: #94a3b8; text-transform: uppercase; font-weight: 600;">${label}</span>
            <span style="font-size: 1.1rem;">${icon}</span>
          </div>
          <div style="font-size: 1.15rem; font-weight: 700; color: ${color};">${val}</div>
          ${subtext ? `<div style="font-size: 0.68rem; color: #64748b;">${subtext}</div>` : ''}
        </div>
      `;
    }).join('');

    return `
      <div class="metric-card" style="background: rgba(255,255,255,0.03); border: 1px solid var(--border-light); border-radius: 8px; padding: 12px;">
        <h3 style="margin: 0 0 10px 0; color: #f8fafc; font-size: 0.95rem;">📊 ${title}</h3>
        <div style="display: grid; grid-template-columns: repeat(${columns}, 1fr); gap: 10px;">
          ${tilesHtml}
        </div>
      </div>
    `;
  }

  public init(_widget: ForecastWidgetConfig, _ctx: WidgetRenderContext): void {
    // Pure DOM rendering
  }
}
